/**
 * @flow
 * @relayHash c9e81556f1b877d66bbae948b16e02de
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectEventTypeFieldQueryVariables = {|
  integrationSourceId?: ?string
|};
export type SelectEventTypeFieldQueryResponse = {|
  +eventTypes: $ReadOnlyArray<{|
    +id: string,
    +name: string,
    +cosmeticName: string,
  |}>
|};
export type SelectEventTypeFieldQuery = {|
  variables: SelectEventTypeFieldQueryVariables,
  response: SelectEventTypeFieldQueryResponse,
|};
*/


/*
query SelectEventTypeFieldQuery(
  $integrationSourceId: String
) {
  eventTypes(integrationSourceId: $integrationSourceId) {
    id
    name
    cosmeticName
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "integrationSourceId",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "eventTypes",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "integrationSourceId",
        "variableName": "integrationSourceId"
      }
    ],
    "concreteType": "EventType",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "cosmeticName",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SelectEventTypeFieldQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SelectEventTypeFieldQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SelectEventTypeFieldQuery",
    "id": null,
    "text": "query SelectEventTypeFieldQuery(\n  $integrationSourceId: String\n) {\n  eventTypes(integrationSourceId: $integrationSourceId) {\n    id\n    name\n    cosmeticName\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '76092d54b2f02b21c26e28023736503f';
module.exports = node;
